const YOUTUBE_SEARCH_API='https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&q=surfing&order=date';

// Load youtube videos
async function getYoutubeVideos() {

  try {
    const response = await fetch(`${YOUTUBE_SEARCH_API}&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`);

    return await response.json();
  }
  catch {
    return []
  }
}

export {
  getYoutubeVideos,
};